<script>
    import { createEventDispatcher } from "svelte";
    export let day;
    export let focus;
    export let column;
    export let selected;
    export let blocked;
    export let id;

    const dispatch = createEventDispatcher();

    $: props = getProps(focus, selected);

    function getProps(focus, selected) {
        let classes = ["day-container"];
        classes.push("col-"+column);
        if(focus.toDateString() == day.toDateString()) {
            classes.push("focus");
        } else if (focus.getMonth() != day.getMonth()) {
            classes.push("outsider");
        }
        
        if(selected?.toDateString() == day.toDateString()) {
            classes.push("selected");
        }

        for (const [key, value] of Object.entries(blocked)) {
            if(!id || key != id) {
                if (day.getTime() == value.start.getTime()) {
                    classes.push("blocked_start");
                } else if (day > value.start && day < value.end) {
                    classes.push("blocked_middle");
                } else if (day.getTime() == value.end.getTime()) {
                    classes.push("blocked_end");
                }
            }
        }

        return { class: classes.join(" ")};
    }

    function sameDay(day, selected) {
        date1.toDateString() == date2.toDateString()
    }
</script>


<div {...props} on:click={() => dispatch("click", day)} on:mouseover={() => dispatch("mouseover", day)} on:focus={() => dispatch("focus", day)}>
    <span class="day">
        {day.getDate()}
    </span>
</div>

<style>
    .day-container {
        display: block;
        cursor: pointer;
        position: relative;
        text-align: center;
        user-select: none;
    }
    
    .weekday {
        text-align: center;
        display: block;
        line-height: 2rem;
        color: grey;
    }

    .day {
        border-radius: 1rem;
        text-align: center;
        display: block;
        margin: 0.2rem auto;
        position: relative;
        width: 2rem;
        height: 2rem;
        line-height: 2rem;
    }
    
    .day:hover {
        background-color: rgb(180, 230, 170);
    }

    .outsider .day {
        color: grey;
    }

    .selected .day {
        background-color: rgb(236, 192, 46);
        color: black;
    }

    .blocked_middle:not(.col-0)::before,
    .blocked_end:not(.col-0)::before {
        display: block;
        position: absolute;
        content: "";
        height: 2rem;
        width: 100%;
        left: -50%;
        right: 50%;
        top: 0.2rem;
        bottom: 0.2rem;
        z-index: -1;
    }

    :global(.valid) .selected .day {
        background-color: rgb(109, 197, 74);
    }


    .blocked_start,
    .blocked_middle,
    .blocked_end {
        cursor: not-allowed;
    }

    .blocked_start .day,
    .blocked_middle .day,
    .blocked_end .day {
        color: rgb(170, 0, 0);
    }

    .blocked_start .day,
    .blocked_end .day {
        background-color: #ffb0b0;
    }

    .blocked_middle .day {
        background-color: #ffdddd;
    }

    .blocked_middle:not(.col-0)::before,
    .blocked_end:not(.col-0)::before {
        background-color: #ffdddd !important;
    }

    :global(.days.focus) .focus .day::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 2rem;
        margin: auto;
        z-index: 2;
        outline: 2px solid blue;
        outline-offset: 2px;
        border-radius: 1rem;
    }
</style>